import './App.css';

function App() {
  const triviaQuestions = [
    { category: 'Media Mania', question: "In The Karate Kid, this is the name of Daniel's karate mentor." },
    { category: 'The Quill & Canvas', question: 'New Moon and Eclipse are books from this bestselling vampire series.' },
    { category: 'Flora, Fauna & Formulas', question: 'This is the common name for the third molars in a human mouth.' },
    { category: 'Playtime & Pastimes', question: 'This tennis legend is often called the "King of Clay."' },
    { category: 'Timelines & Territories', question: 'A Latina girl traditionally celebrates her quinceanera on this birthday.' },
    { category: 'Media Mania', question: "Nicki Minaj sampled this '90s Sir Mix-a-Lot hit for her song 'Anaconda.'" },
    { category: 'The Quill & Canvas', question: 'Scandinavian folklore described this legendary sea monster, which may have been inspired by the giant squid.' },
    { category: 'Flora, Fauna & Formulas', question: "This ocean is where the weather pattern known as 'El Nino' develops." },
    { category: 'Playtime & Pastimes', question: 'This gymnast became the first ever to be awarded a perfect 10 in Olympic history.' },
    { category: 'Timelines & Territories', question: 'Queen Elizabeth II had over 30 dogs of this breed.' },
    { category: 'Media Mania', question: 'Taylor Swift became the youngest person to win a Grammy for Album of the Year with this album.' },
    { category: 'The Quill & Canvas', question: "The protagonist of Vladimir Nabokov's novel The Defense becomes obsessed with this board game." },
    { category: 'Flora, Fauna & Formulas', question: 'Baby zebras are born with stripes of this color before they turn black.' },
    { category: 'Playtime & Pastimes', question: "'Ditch the workout, join the party' is the slogan for this mega dance-fitness craze." },
    { category: 'Timelines & Territories', question: 'In Japan, this American fast-food company is one of the busiest on Christmas Day.' },
    { category: 'Media Mania', question: 'Ariana Grande made her TV debut in this Nickelodeon series.' },
    { category: 'The Quill & Canvas', question: "This mythological beauty's face was said to have 'launched a thousand ships.'" },
    { category: 'Flora, Fauna & Formulas', question: 'This spinning move helps crocodiles subdue and dismember their prey.' },
    { category: 'Playtime & Pastimes', question: 'In karate, this color belt is directly below a black belt.' },
    { category: 'Timelines & Territories', question: 'This sparkling beverage was first created by Dom Perignon in 1670.' },
    { category: 'Media Mania', question: 'In 2017, this long-running British sci-fi series introduced its first female Time Lord.' },
    { category: 'The Quill & Canvas', question: 'This type of humorous five-line poem shares its name with an Irish town.' },
    { category: 'Flora, Fauna & Formulas', question: 'Sound travels about this many times faster in water than in air.' },
    { category: 'Playtime & Pastimes', question: 'The misshapen ear often seen in boxers and wrestlers is commonly referred to as this.' },
    { category: 'Timelines & Territories', question: "This word is commonly used to toast 'cheers' in Germany." },
  ];

  const tickerContent = triviaQuestions.map((q, i) => (
    <span key={i}>
      <span className="ticker-question">
        <span className="ticker-category">{q.category}:</span> {q.question}
      </span>
      <span className="ticker-divider">♠ ♥ ♦ ♣</span>
    </span>
  ));

  const screenshots = [
    { src: '/app-screenshots/screen-1.png', alt: 'How it works screen' },
    { src: '/app-screenshots/screen-2.png', alt: 'Player turn screen' },
    { src: '/app-screenshots/screen-3.png', alt: 'Difficulty selection screen' },
    { src: '/app-screenshots/screen-4.png', alt: 'Question card screen' },
    { src: '/app-screenshots/screen-5.png', alt: 'Answer reveal screen' },
    { src: '/app-screenshots/screen-6.png', alt: 'Hedge card screen' },
  ];

  return (
    <div className="App">
      <div className="bg-orb orb-1" aria-hidden="true"></div>
      <div className="bg-orb orb-2" aria-hidden="true"></div>
      <div className="ticker-wrapper">
        <div className="ticker">
          <div className="ticker-content">{tickerContent}</div>
          <div className="ticker-content" aria-hidden="true">
            {tickerContent}
          </div>
        </div>
      </div>

      <header className="hero-section">
        <div className="logo-section fade-in-up">
          <img src={process.env.PUBLIC_URL + '/KYA_Lettering_1.png'} alt="Know Your Ante?" className="game-logo" />
        </div>

        <div className="content-section fade-in-up delay-1">
          <p className="game-description">
            Test your knowledge and luck in our upcoming pass-and-play local multiplayer trivia app to earn bragging rights among your friends as either the
            <strong> trivia whiz</strong> or the <strong>ultimate rule-bending wagering strategist</strong>!
          </p>
        </div>
      </header>

      <section className="screens-section fade-in-up delay-2">
        <h2 className="section-title">App Preview Screens</h2>
        <p className="section-subtitle">A quick look at the pass-the-device gameplay experience.</p>
        <div className="screenshot-grid">
          {screenshots.map((shot) => (
            <div className="screenshot-card" key={shot.src}>
              <img src={process.env.PUBLIC_URL + shot.src} alt={shot.alt} loading="lazy" />
            </div>
          ))}
        </div>
      </section>

      <section className="video-section fade-in-up delay-3">
        <h2 className="section-title section-title-video">Original Board Game Video</h2>
        <div className="video-container subdued-video">
          <iframe
            src="https://drive.google.com/file/d/1CcjOxVCVAjtLquiAaX9fh2S7_-aa5mMA/preview"
            width="640"
            height="360"
            allow="autoplay"
            title="Know Your Ante? Trivia! Game Preview"
          ></iframe>
        </div>
      </section>

      <footer className="bottom-nav fade-in-up delay-3">
        <a href="/policy" className="bottom-nav-link">
          Privacy Policy
        </a>
        <a href="/support" className="bottom-nav-link">
          Support
        </a>
        <a href="mailto:kyacontact@knowyourante.com" className="bottom-nav-link">
          kyacontact@knowyourante.com
        </a>
      </footer>
    </div>
  );
}

export default App;
